import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';
// import ogp_image from 'src/assets/images/demo-screen-1.jpg';

import '../assets/sass/new-age.scss';
const ogp_image = '/../assets/images/demo-screen-1.jpg';
class Layout extends Component {

  render() {
    const { children } = this.props;
    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <>
            <Helmet
              title={data.site.siteMetadata.title}
              meta={[
                { name: 'description', content: 'C-Coin' },
                { name: 'keywords', content: 'site, web' },
                { property:'og:url', content:'https://c-coin.info'},
                { property:'og:image' , content:'https://c-coin.info/ogp_image.png'},
                { name:'og:description' , content:'How to use C-Coin etc...'},
                { name:'twitter:card',content:'Summary Card'},
                { name:'twitter:title',content:'C-Coin'},
                { name:'twitter:description',content:'How to use C-Coin etc...'},
                { name:'twitter:image' , content: 'https://c-coin.info/ogp_image.png'},
              ]}
            >
              <html lang="en" />
            </Helmet>
            <div className={'page-top'}>{children}</div>
          </>
        )}
      />
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  noFooter: PropTypes.bool,
  noHeader: PropTypes.bool,
  noSiteHeader: PropTypes.bool,
  activeLink: PropTypes.string,
};

export default Layout;
